var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "productimages" } }, [
    _c("div", {
      staticClass: "contentText",
      domProps: { innerHTML: _vm._s(this.$root.language.wsm_proHeadText) },
    }),
    _c(
      "div",
      [
        _c("ProductList", {
          attrs: {
            translations: this.$root.language,
            settings: this.$root.settings,
            flaptype: this.$root.flaptype,
            hidecat: this.$root.hidecat,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }